import React, { useState, useEffect } from "react";
import Header from "./Header";
import Home from "./Home";
import Footer from "./Footer";
import Snack from "./Snack";
import About from "./About";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import io from "socket.io-client";
import globalContext from './globalContext';

const api = (process.env.REACT_APP_MODE === process.env.REACT_APP_PRODUCTION)
  ? process.env.REACT_APP_BACKEND_API
  : "http://localhost:3001";

const socket = io.connect(api);
const getBasename = (path) => path.substr(0, path.lastIndexOf("/"));

function App() {
  const [loading, setLoading] = useState(false);
  const [notes, setNotes] = useState([]);
  const [open, setOpen] = useState({
    shouldOpen: false,
    msg: "",
  });

  useEffect(() => {
    getTasks(false);

    socket.on("receive_msg", (data) => {
      if (data.shouldUpdate) {
        console.log("Socket hit recieved", data);
        if (data.newData && data.newData.length > 0) {
          setNotes(data.newData);
          console.log("new notes set");
        } else {
          alert("Invalid data response");
        }
      }
    });

    return () => socket.off("receive_msg");
  }, []);

  const getTasks = async (alertOthers) => {
    console.log("Getting tasks");
    if (alertOthers) {
      socket.emit("send_msg", { shouldUpdate: true });
    }
    const serverTasks = await fetchTasks();
    setNotes(serverTasks);

    setLoading(false);
  };

  const fetchTasks = async () => {
    const res = await fetch(api);
    const data = await res.json();

    // console.log(data)
    return data;
  };

  const addNote = async (newNote) => {
    setLoading(true);
    const res = await fetch(`${api}/add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newNote),
    });
    const data = await res.json();

    getTasks(true);
  };

  const deleteNote = async (id) => {
    const res = await fetch(`${api}/DELETE/${id}`);
    const data = await res.json();

    getTasks(true);
  };

  return (
    <Router basename={"/keeper"}>
      <globalContext.Provider
        value={{
          socket: socket,
          snack: { setOpen: setOpen, open: open },
          notes: { addNote: addNote },
          loader: { loading: loading, setLoading: setLoading },
        }}
      >
        <div>
          <Header />
          <div
            style={{
              textAlign: "center",
              marginTop: "40px",
              marginBottom: "40px",
            }}
          >
            <Link style={{ margin: "20px" }} to="/">
              Home
            </Link>
            <Link to="/about">About Us</Link>
          </div>
          <Routes>
            <Route
              exact
              path="/"
              element={<Home notes={notes} deleteNote={deleteNote} />}
            />
            <Route exact path="/about" element={<About />} />
          </Routes>

          <Snack />
          <Footer />
        </div>
      </globalContext.Provider>
    </Router>
  );
}

export default App;
